export default [
    {
        "id": 0,
        "name": "United Kingdom",
        "iso2": "GB"
    },
    {
        "id": 1,
        "name": "Afghanistan (‫افغانستان‬‎)",
        "iso2": "AF"
    },
    {
        "id": 2,
        "name": "Albania (Shqipëri)",
        "iso2": "AL"
    },
    {
        "id": 3,
        "name": "Algeria (‫الجزائر‬‎)",
        "iso2": "DZ"
    },
    {
        "id": 4,
        "name": "American Samoa",
        "iso2": "AS"
    },
    {
        "id": 5,
        "name": "Andorra",
        "iso2": "AD"
    },
    {
        "id": 6,
        "name": "Angola",
        "iso2": "AO"
    },
    {
        "id": 7,
        "name": "Anguilla",
        "iso2": "AI"
    },
    {
        "id": 8,
        "name": "Antigua and Barbuda",
        "iso2": "AG"
    },
    {
        "id": 9,
        "name": "Argentina",
        "iso2": "AR"
    },
    {
        "id": 10,
        "name": "Armenia (Հայաստան)",
        "iso2": "AM"
    },
    {
        "id": 11,
        "name": "Aruba",
        "iso2": "AW"
    },
    {
        "id": 12,
        "name": "Australia",
        "iso2": "AU"
    },
    {
        "id": 13,
        "name": "Austria (Österreich)",
        "iso2": "AT"
    },
    {
        "id": 14,
        "name": "Azerbaijan (Azərbaycan)",
        "iso2": "AZ"
    },
    {
        "id": 15,
        "name": "Bahamas",
        "iso2": "BS"
    },
    {
        "id": 16,
        "name": "Bahrain (‫البحرين‬‎)",
        "iso2": "BH"
    },
    {
        "id": 17,
        "name": "Bangladesh (বাংলাদেশ)",
        "iso2": "BD"
    },
    {
        "id": 18,
        "name": "Barbados",
        "iso2": "BB"
    },
    {
        "id": 19,
        "name": "Belarus (Беларусь)",
        "iso2": "BY"
    },
    {
        "id": 20,
        "name": "Belgium (België)",
        "iso2": "BE"
    },
    {
        "id": 21,
        "name": "Belize",
        "iso2": "BZ"
    },
    {
        "id": 22,
        "name": "Benin (Bénin)",
        "iso2": "BJ"
    },
    {
        "id": 23,
        "name": "Bermuda",
        "iso2": "BM"
    },
    {
        "id": 24,
        "name": "Bhutan (འབྲུག)",
        "iso2": "BT"
    },
    {
        "id": 25,
        "name": "Bolivia",
        "iso2": "BO"
    },
    {
        "id": 26,
        "name": "Bosnia and Herzegovina (Босна и Херцеговина)",
        "iso2": "BA"
    },
    {
        "id": 27,
        "name": "Botswana",
        "iso2": "BW"
    },
    {
        "id": 28,
        "name": "Brazil (Brasil)",
        "iso2": "BR"
    },
    {
        "id": 29,
        "name": "British Indian Ocean Territory",
        "iso2": "IO"
    },
    {
        "id": 30,
        "name": "British Virgin Islands",
        "iso2": "VG"
    },
    {
        "id": 31,
        "name": "Brunei",
        "iso2": "BN"
    },
    {
        "id": 32,
        "name": "Bulgaria (България)",
        "iso2": "BG"
    },
    {
        "id": 33,
        "name": "Burkina Faso",
        "iso2": "BF"
    },
    {
        "id": 34,
        "name": "Burundi (Uburundi)",
        "iso2": "BI"
    },
    {
        "id": 35,
        "name": "Cambodia (កម្ពុជា)",
        "iso2": "KH"
    },
    {
        "id": 36,
        "name": "Cameroon (Cameroun)",
        "iso2": "CM"
    },
    {
        "id": 37,
        "name": "Canada",
        "iso2": "CA"
    },
    {
        "id": 38,
        "name": "Cape Verde (Kabu Verdi)",
        "iso2": "CV"
    },
    {
        "id": 39,
        "name": "Caribbean Netherlands",
        "iso2": "BQ"
    },
    {
        "id": 40,
        "name": "Cayman Islands",
        "iso2": "KY"
    },
    {
        "id": 41,
        "name": "Central African Republic (République centrafricaine)",
        "iso2": "CF"
    },
    {
        "id": 42,
        "name": "Chad (Tchad)",
        "iso2": "TD"
    },
    {
        "id": 43,
        "name": "Chile",
        "iso2": "CL"
    },
    {
        "id": 44,
        "name": "China (中国)",
        "iso2": "CN"
    },
    {
        "id": 45,
        "name": "Christmas Island",
        "iso2": "CX"
    },
    {
        "id": 46,
        "name": "Cocos (Keeling) Islands",
        "iso2": "CC"
    },
    {
        "id": 47,
        "name": "Colombia",
        "iso2": "CO"
    },
    {
        "id": 48,
        "name": "Comoros (‫جزر القمر‬‎)",
        "iso2": "KM"
    },
    {
        "id": 49,
        "name": "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
        "iso2": "CD"
    },
    {
        "id": 50,
        "name": "Congo (Republic) (Congo-Brazzaville)",
        "iso2": "CG"
    },
    {
        "id": 51,
        "name": "Cook Islands",
        "iso2": "CK"
    },
    {
        "id": 52,
        "name": "Costa Rica",
        "iso2": "CR"
    },
    {
        "id": 53,
        "name": "Côte d’Ivoire",
        "iso2": "CI"
    },
    {
        "id": 54,
        "name": "Croatia (Hrvatska)",
        "iso2": "HR"
    },
    {
        "id": 55,
        "name": "Cuba",
        "iso2": "CU"
    },
    {
        "id": 56,
        "name": "Curaçao",
        "iso2": "CW"
    },
    {
        "id": 57,
        "name": "Cyprus (Κύπρος)",
        "iso2": "CY"
    },
    {
        "id": 58,
        "name": "Czech Republic (Česká republika)",
        "iso2": "CZ"
    },
    {
        "id": 59,
        "name": "Denmark (Danmark)",
        "iso2": "DK"
    },
    {
        "id": 60,
        "name": "Djibouti",
        "iso2": "DJ"
    },
    {
        "id": 61,
        "name": "Dominica",
        "iso2": "DM"
    },
    {
        "id": 62,
        "name": "Dominican Republic (República Dominicana)",
        "iso2": "DO"
    },
    {
        "id": 63,
        "name": "Ecuador",
        "iso2": "EC"
    },
    {
        "id": 64,
        "name": "Egypt (‫مصر‬‎)",
        "iso2": "EG"
    },
    {
        "id": 65,
        "name": "El Salvador",
        "iso2": "SV"
    },
    {
        "id": 66,
        "name": "Equatorial Guinea (Guinea Ecuatorial)",
        "iso2": "GQ"
    },
    {
        "id": 67,
        "name": "Eritrea",
        "iso2": "ER"
    },
    {
        "id": 68,
        "name": "Estonia (Eesti)",
        "iso2": "EE"
    },
    {
        "id": 69,
        "name": "Ethiopia",
        "iso2": "ET"
    },
    {
        "id": 70,
        "name": "Falkland Islands (Islas Malvinas)",
        "iso2": "FK"
    },
    {
        "id": 71,
        "name": "Faroe Islands (Føroyar)",
        "iso2": "FO"
    },
    {
        "id": 72,
        "name": "Fiji",
        "iso2": "FJ"
    },
    {
        "id": 73,
        "name": "Finland (Suomi)",
        "iso2": "FI"
    },
    {
        "id": 74,
        "name": "France",
        "iso2": "FR"
    },
    {
        "id": 75,
        "name": "French Guiana (Guyane française)",
        "iso2": "GF"
    },
    {
        "id": 76,
        "name": "French Polynesia (Polynésie française)",
        "iso2": "PF"
    },
    {
        "id": 77,
        "name": "Gabon",
        "iso2": "GA"
    },
    {
        "id": 78,
        "name": "Gambia",
        "iso2": "GM"
    },
    {
        "id": 79,
        "name": "Georgia (საქართველო)",
        "iso2": "GE"
    },
    {
        "id": 80,
        "name": "Germany (Deutschland)",
        "iso2": "DE"
    },
    {
        "id": 81,
        "name": "Ghana (Gaana)",
        "iso2": "GH"
    },
    {
        "id": 82,
        "name": "Gibraltar",
        "iso2": "GI"
    },
    {
        "id": 83,
        "name": "Greece (Ελλάδα)",
        "iso2": "GR"
    },
    {
        "id": 84,
        "name": "Greenland (Kalaallit Nunaat)",
        "iso2": "GL"
    },
    {
        "id": 85,
        "name": "Grenada",
        "iso2": "GD"
    },
    {
        "id": 86,
        "name": "Guadeloupe",
        "iso2": "GP"
    },
    {
        "id": 87,
        "name": "Guam",
        "iso2": "GU"
    },
    {
        "id": 88,
        "name": "Guatemala",
        "iso2": "GT"
    },
    {
        "id": 89,
        "name": "Guernsey",
        "iso2": "GG"
    },
    {
        "id": 90,
        "name": "Guinea (Guinée)",
        "iso2": "GN"
    },
    {
        "id": 91,
        "name": "Guinea-Bissau (Guiné Bissau)",
        "iso2": "GW"
    },
    {
        "id": 92,
        "name": "Guyana",
        "iso2": "GY"
    },
    {
        "id": 93,
        "name": "Haiti",
        "iso2": "HT"
    },
    {
        "id": 94,
        "name": "Honduras",
        "iso2": "HN"
    },
    {
        "id": 95,
        "name": "Hong Kong (香港)",
        "iso2": "HK"
    },
    {
        "id": 96,
        "name": "Hungary (Magyarország)",
        "iso2": "HU"
    },
    {
        "id": 97,
        "name": "Iceland (Ísland)",
        "iso2": "IS"
    },
    {
        "id": 98,
        "name": "India (भारत)",
        "iso2": "IN"
    },
    {
        "id": 99,
        "name": "Indonesia",
        "iso2": "ID"
    },
    {
        "id": 100,
        "name": "Iran (‫ایران‬‎)",
        "iso2": "IR"
    },
    {
        "id": 101,
        "name": "Iraq (‫العراق‬‎)",
        "iso2": "IQ"
    },
    {
        "id": 102,
        "name": "Ireland",
        "iso2": "IE"
    },
    {
        "id": 103,
        "name": "Isle of Man",
        "iso2": "IM"
    },
    {
        "id": 104,
        "name": "Israel (‫ישראל‬‎)",
        "iso2": "IL"
    },
    {
        "id": 105,
        "name": "Italy (Italia)",
        "iso2": "IT"
    },
    {
        "id": 106,
        "name": "Jamaica",
        "iso2": "JM"
    },
    {
        "id": 107,
        "name": "Japan (日本)",
        "iso2": "JP"
    },
    {
        "id": 108,
        "name": "Jersey",
        "iso2": "JE"
    },
    {
        "id": 109,
        "name": "Jordan (‫الأردن‬‎)",
        "iso2": "JO"
    },
    {
        "id": 110,
        "name": "Kazakhstan (Казахстан)",
        "iso2": "KZ"
    },
    {
        "id": 111,
        "name": "Kenya",
        "iso2": "KE"
    },
    {
        "id": 112,
        "name": "Kiribati",
        "iso2": "KI"
    },
    {
        "id": 113,
        "name": "Kosovo",
        "iso2": "XK"
    },
    {
        "id": 114,
        "name": "Kuwait (‫الكويت‬‎)",
        "iso2": "KW"
    },
    {
        "id": 115,
        "name": "Kyrgyzstan (Кыргызстан)",
        "iso2": "KG"
    },
    {
        "id": 116,
        "name": "Laos (ລາວ)",
        "iso2": "LA"
    },
    {
        "id": 117,
        "name": "Latvia (Latvija)",
        "iso2": "LV"
    },
    {
        "id": 118,
        "name": "Lebanon (‫لبنان‬‎)",
        "iso2": "LB"
    },
    {
        "id": 119,
        "name": "Lesotho",
        "iso2": "LS"
    },
    {
        "id": 120,
        "name": "Liberia",
        "iso2": "LR"
    },
    {
        "id": 121,
        "name": "Libya (‫ليبيا‬‎)",
        "iso2": "LY"
    },
    {
        "id": 122,
        "name": "Liechtenstein",
        "iso2": "LI"
    },
    {
        "id": 123,
        "name": "Lithuania (Lietuva)",
        "iso2": "LT"
    },
    {
        "id": 124,
        "name": "Luxembourg",
        "iso2": "LU"
    },
    {
        "id": 125,
        "name": "Macau (澳門)",
        "iso2": "MO"
    },
    {
        "id": 126,
        "name": "Macedonia (FYROM) (Македонија)",
        "iso2": "MK"
    },
    {
        "id": 127,
        "name": "Madagascar (Madagasikara)",
        "iso2": "MG"
    },
    {
        "id": 128,
        "name": "Malawi",
        "iso2": "MW"
    },
    {
        "id": 129,
        "name": "Malaysia",
        "iso2": "MY"
    },
    {
        "id": 130,
        "name": "Maldives",
        "iso2": "MV"
    },
    {
        "id": 131,
        "name": "Mali",
        "iso2": "ML"
    },
    {
        "id": 132,
        "name": "Malta",
        "iso2": "MT"
    },
    {
        "id": 133,
        "name": "Marshall Islands",
        "iso2": "MH"
    },
    {
        "id": 134,
        "name": "Martinique",
        "iso2": "MQ"
    },
    {
        "id": 135,
        "name": "Mauritania (‫موريتانيا‬‎)",
        "iso2": "MR"
    },
    {
        "id": 136,
        "name": "Mauritius (Moris)",
        "iso2": "MU"
    },
    {
        "id": 137,
        "name": "Mayotte",
        "iso2": "YT"
    },
    {
        "id": 138,
        "name": "Mexico (México)",
        "iso2": "MX"
    },
    {
        "id": 139,
        "name": "Micronesia",
        "iso2": "FM"
    },
    {
        "id": 140,
        "name": "Moldova (Republica Moldova)",
        "iso2": "MD"
    },
    {
        "id": 141,
        "name": "Monaco",
        "iso2": "MC"
    },
    {
        "id": 142,
        "name": "Mongolia (Монгол)",
        "iso2": "MN"
    },
    {
        "id": 143,
        "name": "Montenegro (Crna Gora)",
        "iso2": "ME"
    },
    {
        "id": 144,
        "name": "Montserrat",
        "iso2": "MS"
    },
    {
        "id": 145,
        "name": "Morocco (‫المغرب‬‎)",
        "iso2": "MA"
    },
    {
        "id": 146,
        "name": "Mozambique (Moçambique)",
        "iso2": "MZ"
    },
    {
        "id": 147,
        "name": "Myanmar (Burma) (မြန်မာ)",
        "iso2": "MM"
    },
    {
        "id": 148,
        "name": "Namibia (Namibië)",
        "iso2": "NA"
    },
    {
        "id": 149,
        "name": "Nauru",
        "iso2": "NR"
    },
    {
        "id": 150,
        "name": "Nepal (नेपाल)",
        "iso2": "NP"
    },
    {
        "id": 151,
        "name": "Netherlands (Nederland)",
        "iso2": "NL"
    },
    {
        "id": 152,
        "name": "New Caledonia (Nouvelle-Calédonie)",
        "iso2": "NC"
    },
    {
        "id": 153,
        "name": "New Zealand",
        "iso2": "NZ"
    },
    {
        "id": 154,
        "name": "Nicaragua",
        "iso2": "NI"
    },
    {
        "id": 155,
        "name": "Niger (Nijar)",
        "iso2": "NE"
    },
    {
        "id": 156,
        "name": "Nigeria",
        "iso2": "NG"
    },
    {
        "id": 157,
        "name": "Niue",
        "iso2": "NU"
    },
    {
        "id": 158,
        "name": "Norfolk Island",
        "iso2": "NF"
    },
    {
        "id": 159,
        "name": "North Korea (조선 민주주의 인민 공화국)",
        "iso2": "KP"
    },
    {
        "id": 160,
        "name": "Northern Mariana Islands",
        "iso2": "MP"
    },
    {
        "id": 161,
        "name": "Norway (Norge)",
        "iso2": "NO"
    },
    {
        "id": 162,
        "name": "Oman (‫عُمان‬‎)",
        "iso2": "OM"
    },
    {
        "id": 163,
        "name": "Pakistan (‫پاکستان‬‎)",
        "iso2": "PK"
    },
    {
        "id": 164,
        "name": "Palau",
        "iso2": "PW"
    },
    {
        "id": 165,
        "name": "Palestine (‫فلسطين‬‎)",
        "iso2": "PS"
    },
    {
        "id": 166,
        "name": "Panama (Panamá)",
        "iso2": "PA"
    },
    {
        "id": 167,
        "name": "Papua New Guinea",
        "iso2": "PG"
    },
    {
        "id": 168,
        "name": "Paraguay",
        "iso2": "PY"
    },
    {
        "id": 169,
        "name": "Peru (Perú)",
        "iso2": "PE"
    },
    {
        "id": 170,
        "name": "Philippines",
        "iso2": "PH"
    },
    {
        "id": 171,
        "name": "Poland (Polska)",
        "iso2": "PL"
    },
    {
        "id": 172,
        "name": "Portugal",
        "iso2": "PT"
    },
    {
        "id": 173,
        "name": "Puerto Rico",
        "iso2": "PR"
    },
    {
        "id": 174,
        "name": "Qatar (‫قطر‬‎)",
        "iso2": "QA"
    },
    {
        "id": 175,
        "name": "Réunion (La Réunion)",
        "iso2": "RE"
    },
    {
        "id": 176,
        "name": "Romania (România)",
        "iso2": "RO"
    },
    {
        "id": 177,
        "name": "Russia (Россия)",
        "iso2": "RU"
    },
    {
        "id": 178,
        "name": "Rwanda",
        "iso2": "RW"
    },
    {
        "id": 179,
        "name": "Saint Barthélemy (Saint-Barthélemy)",
        "iso2": "BL"
    },
    {
        "id": 180,
        "name": "Saint Helena",
        "iso2": "SH"
    },
    {
        "id": 181,
        "name": "Saint Kitts and Nevis",
        "iso2": "KN"
    },
    {
        "id": 182,
        "name": "Saint Lucia",
        "iso2": "LC"
    },
    {
        "id": 183,
        "name": "Saint Martin (Saint-Martin (partie française))",
        "iso2": "MF"
    },
    {
        "id": 184,
        "name": "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
        "iso2": "PM"
    },
    {
        "id": 185,
        "name": "Saint Vincent and the Grenadines",
        "iso2": "VC"
    },
    {
        "id": 186,
        "name": "Samoa",
        "iso2": "WS"
    },
    {
        "id": 187,
        "name": "San Marino",
        "iso2": "SM"
    },
    {
        "id": 188,
        "name": "São Tomé and Príncipe (São Tomé e Príncipe)",
        "iso2": "ST"
    },
    {
        "id": 189,
        "name": "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
        "iso2": "SA"
    },
    {
        "id": 190,
        "name": "Senegal (Sénégal)",
        "iso2": "SN"
    },
    {
        "id": 191,
        "name": "Serbia (Србија)",
        "iso2": "RS"
    },
    {
        "id": 192,
        "name": "Seychelles",
        "iso2": "SC"
    },
    {
        "id": 193,
        "name": "Sierra Leone",
        "iso2": "SL"
    },
    {
        "id": 194,
        "name": "Singapore",
        "iso2": "SG"
    },
    {
        "id": 195,
        "name": "Sint Maarten",
        "iso2": "SX"
    },
    {
        "id": 196,
        "name": "Slovakia (Slovensko)",
        "iso2": "SK"
    },
    {
        "id": 197,
        "name": "Slovenia (Slovenija)",
        "iso2": "SI"
    },
    {
        "id": 198,
        "name": "Solomon Islands",
        "iso2": "SB"
    },
    {
        "id": 199,
        "name": "Somalia (Soomaaliya)",
        "iso2": "SO"
    },
    {
        "id": 200,
        "name": "South Africa",
        "iso2": "ZA"
    },
    {
        "id": 201,
        "name": "South Korea (대한민국)",
        "iso2": "KR"
    },
    {
        "id": 202,
        "name": "South Sudan (‫جنوب السودان‬‎)",
        "iso2": "SS"
    },
    {
        "id": 203,
        "name": "Spain (España)",
        "iso2": "ES"
    },
    {
        "id": 204,
        "name": "Sri Lanka (ශ්‍රී ලංකාව)",
        "iso2": "LK"
    },
    {
        "id": 205,
        "name": "Sudan (‫السودان‬‎)",
        "iso2": "SD"
    },
    {
        "id": 206,
        "name": "Suriname",
        "iso2": "SR"
    },
    {
        "id": 207,
        "name": "Svalbard and Jan Mayen",
        "iso2": "SJ"
    },
    {
        "id": 208,
        "name": "Swaziland",
        "iso2": "SZ"
    },
    {
        "id": 209,
        "name": "Sweden (Sverige)",
        "iso2": "SE"
    },
    {
        "id": 210,
        "name": "Switzerland (Schweiz)",
        "iso2": "CH"
    },
    {
        "id": 211,
        "name": "Syria (‫سوريا‬‎)",
        "iso2": "SY"
    },
    {
        "id": 212,
        "name": "Taiwan (台灣)",
        "iso2": "TW"
    },
    {
        "id": 213,
        "name": "Tajikistan",
        "iso2": "TJ"
    },
    {
        "id": 214,
        "name": "Tanzania",
        "iso2": "TZ"
    },
    {
        "id": 215,
        "name": "Thailand (ไทย)",
        "iso2": "TH"
    },
    {
        "id": 216,
        "name": "Timor-Leste",
        "iso2": "TL"
    },
    {
        "id": 217,
        "name": "Togo",
        "iso2": "TG"
    },
    {
        "id": 218,
        "name": "Tokelau",
        "iso2": "TK"
    },
    {
        "id": 219,
        "name": "Tonga",
        "iso2": "TO"
    },
    {
        "id": 220,
        "name": "Trinidad and Tobago",
        "iso2": "TT"
    },
    {
        "id": 221,
        "name": "Tunisia (‫تونس‬‎)",
        "iso2": "TN"
    },
    {
        "id": 222,
        "name": "Turkey (Türkiye)",
        "iso2": "TR"
    },
    {
        "id": 223,
        "name": "Turkmenistan",
        "iso2": "TM"
    },
    {
        "id": 224,
        "name": "Turks and Caicos Islands",
        "iso2": "TC"
    },
    {
        "id": 225,
        "name": "Tuvalu",
        "iso2": "TV"
    },
    {
        "id": 226,
        "name": "U.S. Virgin Islands",
        "iso2": "VI"
    },
    {
        "id": 227,
        "name": "Uganda",
        "iso2": "UG"
    },
    {
        "id": 228,
        "name": "Ukraine (Україна)",
        "iso2": "UA"
    },
    {
        "id": 229,
        "name": "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
        "iso2": "AE"
    },
    {
        "id": 230,
        "name": "United States",
        "iso2": "US"
    },
    {
        "id": 231,
        "name": "Uruguay",
        "iso2": "UY"
    },
    {
        "id": 232,
        "name": "Uzbekistan (Oʻzbekiston)",
        "iso2": "UZ"
    },
    {
        "id": 233,
        "name": "Vanuatu",
        "iso2": "VU"
    },
    {
        "id": 234,
        "name": "Vatican City (Città del Vaticano)",
        "iso2": "VA"
    },
    {
        "id": 235,
        "name": "Venezuela",
        "iso2": "VE"
    },
    {
        "id": 236,
        "name": "Vietnam (Việt Nam)",
        "iso2": "VN"
    },
    {
        "id": 237,
        "name": "Wallis and Futuna",
        "iso2": "WF"
    },
    {
        "id": 238,
        "name": "Western Sahara (‫الصحراء الغربية‬‎)",
        "iso2": "EH"
    },
    {
        "id": 239,
        "name": "Yemen (‫اليمن‬‎)",
        "iso2": "YE"
    },
    {
        "id": 240,
        "name": "Zambia",
        "iso2": "ZM"
    },
    {
        "id": 241,
        "name": "Zimbabwe",
        "iso2": "ZW"
    },
    {
        "id": 242,
        "name": "Åland Islands",
        "iso2": "AX"
    }
];